/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AuthorizationStatusResponseFromJSON, } from '../models/index';
/**
 *
 */
export class SpapiAuthControllerApi extends runtime.BaseAPI {
    /**
     */
    async checkAuthorizationStatusRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/spapi/auth/status`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AuthorizationStatusResponseFromJSON));
    }
    /**
     */
    async checkAuthorizationStatus(initOverrides) {
        const response = await this.checkAuthorizationStatusRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAmazonRedirectUriRaw(requestParameters, initOverrides) {
        if (requestParameters['region'] == null) {
            throw new runtime.RequiredError('region', 'Required parameter "region" was null or undefined when calling getAmazonRedirectUri().');
        }
        const queryParameters = {};
        if (requestParameters['region'] != null) {
            queryParameters['region'] = requestParameters['region'];
        }
        if (requestParameters['app'] != null) {
            queryParameters['app'] = requestParameters['app'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/spapi/auth/redirect`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async getAmazonRedirectUri(requestParameters, initOverrides) {
        const response = await this.getAmazonRedirectUriRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async handleCallbackRaw(requestParameters, initOverrides) {
        if (requestParameters['spapiOauthCode'] == null) {
            throw new runtime.RequiredError('spapiOauthCode', 'Required parameter "spapiOauthCode" was null or undefined when calling handleCallback().');
        }
        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError('state', 'Required parameter "state" was null or undefined when calling handleCallback().');
        }
        const queryParameters = {};
        if (requestParameters['spapiOauthCode'] != null) {
            queryParameters['spapi_oauth_code'] = requestParameters['spapiOauthCode'];
        }
        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }
        if (requestParameters['sellingPartnerId'] != null) {
            queryParameters['selling_partner_id'] = requestParameters['sellingPartnerId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/spapi/auth/callback`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async handleCallback(requestParameters, initOverrides) {
        const response = await this.handleCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
